
export const DateFormatRegex = /^\d\d\d\d-(0?[1-9]|[1][0-2])-(0?[1-9]|[12][0-9]|3[01])\s\d\d:\d\d:\d\d$/
export const AirwayBillRegex = /[A-Za-z]{3}[\w]+/;
export const AirwayBill = /^[A-Za-z]{1}[0-9]{10}$/;
export const AirlineRegex = /^((?:[a-z][a-z]|[a-z][\d]|[\d][a-z])[a-z]?)([\d]{1,4}[a-z]?)$/gi;
export const NumericRegex = /^[0-9\s]*$/;
export const SWIFTRegex = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
export const BankAccountRegex = /^(\d{3,12})$/;
export const IBANRegex = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AE)\d{21}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/;
export const PhoneNumberRegex = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NumericWithDecimalRegex = /^[0-9][\.\d]*(,\d+)?$/;
export const NumericWithTwoDecimalRegex = /^[1-9]([0-9]*)+(\.[1-9]([0-9]*){0,2})?$/g;
export const NumericTwoDecimalRegex = /^[1-9]([0-9]*)+(\.[1-9]([0-9]*){0,2})?$/g;
export const NumericTwoDecimalWithZeroRegex = /^[0-9]([0-9]*)+(\.[0-9]([0-9]*){0,2})?$/g;
export const AlphabetsRegex = /^[a-zA-Z]/;
export const NumericWithComma = /[1-9]+(,[1-9]+)*/;
export const FourDigitsRegex = /^\d{0,4}$/;
export const FiveDigitsWithNumericRegex = /\d{0,5}(?:\.\d{0,6})?/;
export const TwoDigitsRegex = /^\d{0,2}$/;
export const ThreeDigitsRegex = /^\d{0,3}$/;
export const ArabicAlphabetsRegex = /^[\u0621-\u064A\s]+$/;
export const oneAlphaCodeRegex = /^(([A-Za-z]{1}))$/;
export const twoAlphaCodeRegex = /^(([A-Za-z]{2}))$/;
export const TwoDigitDecimalWithOneDigitPrecisionRegex = /^\d{0,2}$|^\d{0,2}\.{1}\d{1}$/
export const NumericWithSpecialCharacter = /^-?[1-9]([0-9]*)+(\.[1-9]([0-9]*){0,2})?$/g
export const SaudiPlateNumberRegex = /^[1-9][0-9]*\s[A-Za-z][A-Za-z][A-Za-z]/;
export const NameFieldRegex = /^(?!\s*$)[a-zA-Z\s]+$/;
export const ArabicNameFieldRegex = /^(?!\s*$)[\p{Script=Arabic}\s]+$/u;
export const IdentityNumberRegex = /^(?!\s*$)[0-9]{10}$/;
export const vehicleTypeFieldRegex = /^(?!\s*$)[a-zA-Z\s]{3,50}$/;
export const NameFieldAllLettersRegex = /^(?!\s*$)[\p{L}\s]+$/u;
export const NumericRegexNotAllowingZero = /^(?!0+$)[0-9]+$/;
export const IqamaNumberRegex = /^\d{10}$/;

export const remarksLengthRegex = /^.{0,250}$/;
export const PositiveNonZeroDecimalNumberRegex = /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/;
export const markenHAWBLengthRegex = /^(?=[A-Za-z\d]{10,14}$)(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/;
export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[^\s]{8,15}$/;

export const ShortAddressRegex = /^[A-Za-z]{4}\d{4}$/

export const contactNameRegex = /^[A-Za-z\u0621-\u064A]+(?:[\s!@#$%^&*()_+\-=\[\]{};:'"\\|,.<>\/?~`]+[A-Za-z\u0621-\u064A]+)*$/;

export const numericInputRegex = /^-?\d+(\.\d+)?$/;